export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13522.b5a21b24.jpg";